<template>
    <div>
        
        <div v-if=(row.new) class="absolute">
            <span class="inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white">
                New
            </span>
        </div>   
        <div v-if="status" class="absolute pt-1 pl-1">
            <span class="">
                <XCircleIcon class="w-5 text-rose-700"/>
            </span>
        </div>                         

        <button type="button" class="group p-2 w-full flex flex-col justify-center items-center rounded-md border-gray-200 shadow-sm  text-left ">
           
            <span class="block flex-shrink-0 pb-2">
                <Avatar :avatar="row.avatar" size='md' class="inline-block rounded-full" />                    
            </span>

            <span class="block text-sm font-medium  truncate">{{ row.name }}</span>
            <span class="block text-xs font-light truncate">{{ row.email }}</span>
            <div v-if="row.roles && row.roles.name" class="pt-1 text-xs font-normal rounded-md  flex items-center gap-1" >
                <div :class="(row.roles.color || 'bg-gray-500')" class="rounded-full h-2 w-2"></div>    {{row.roles.name}}
            </div>

            <div class="w-full flex justify-between pt-2">

            </div>
                
        </button>
    </div>
</template>

<script>
import { XCircleIcon  } from '@heroicons/vue/24/solid'

export default {

    name:"UserCardSmall",
    props: {
        row: {
            type: Object,
            required: true
        },
        status: {
            type: Boolean,
            default: false
        },
    },
    methods: {

       
    },
    components: {
        XCircleIcon,
    },
}
</script>